export const getImageURL = image => {
  if (!image) {
    return null
  }
  return image.formats?.screenWeb ? image.formats.screenWeb.url : image.url
}
